export const FAMILIES = ["ACLS", "ASLS", "BLS", "PALS", "Heartsaver"];
export const OTHER_FAMILY = "Other";
export const NO_EDITION = "None";

/** Status metadata: tone drives the chip colour, icon names come from ./icons. */
export const STATUS = {
  active: { label: "Active", icon: "checkCircle" },
  verified: { label: "Verified · inactive", icon: "minusCircle" },
  unverified: { label: "Not verified", icon: "alert" },
  inactive: { label: "Inactive", icon: "minusCircle" },
};

/** Which products to show by their standard course: all, those with a course, or those still without one. */
export const COURSE_FILTERS = [["all", "All"], ["linked", "Linked"], ["unlinked", "No course yet"]];

export function matchesCourseFilter(filter, courseLinks, product) {
  if (!courseLinks || filter === "all") return true;
  return filter === "linked" ? Boolean(courseLinks[product.key]) : !courseLinks[product.key];
}

/** The certificate standards a catalog product can belong to. AHA is the only connector today; a new one adds its own entry. */
export const CERTIFICATE_STANDARDS = ["AHA"];

/** Every product in this catalog is an AHA product; this is where a second connector's products would say otherwise. */
export const standardOf = () => "AHA";

export const matchesStandard = (standard, product) => standard === "all" || standardOf(product) === standard;

export const SORTS = { name: "Name A–Z", number: "Product number", edition: "Edition, newest first" };

/** One status per product: a product switched off in the catalog wins over its environment flags. */
export function statusOf(product) {
  if (product.active === false) return "inactive";
  const env = product.environment || {};
  if (env.active) return "active";
  return env.verified ? "verified" : "unverified";
}

/** The catalog has no family column, so it is derived from the leading word of the product name. */
export function familyOf(product) {
  const first = (product.name || "").trim().split(/\s+/)[0].toLowerCase();
  return FAMILIES.find((f) => f.toLowerCase() === first) || OTHER_FAMILY;
}

const numberOf = (p) => p.environment?.productNumber || "";
const editionRank = (p) => (p.edition ? -Number(p.edition) || 0 : 0);
const byName = (a, b) => a.name.localeCompare(b.name) || editionRank(a) - editionRank(b);

export function filterProducts(products, { query = "", statuses = [], families = [], editions = [] } = {}) {
  const q = query.trim().toLowerCase();
  return products.filter((p) => (!q || `${p.name} ${p.key} ${numberOf(p)}`.toLowerCase().includes(q))
    && (!statuses.length || statuses.includes(statusOf(p)))
    && (!families.length || families.includes(familyOf(p)))
    && (!editions.length || editions.includes(p.edition || NO_EDITION)));
}

export function sortProducts(products, sort = "name") {
  const compare = sort === "number" ? (a, b) => numberOf(a).localeCompare(numberOf(b)) || byName(a, b)
    : sort === "edition" ? (a, b) => editionRank(a) - editionRank(b) || byName(a, b)
      : byName;
  return [...products].sort(compare);
}

/** [[family, products]] in catalog family order with Other last; empty families are dropped. */
export function groupByFamily(products) {
  return [...FAMILIES, OTHER_FAMILY]
    .map((family) => [family, products.filter((p) => familyOf(p) === family)])
    .filter(([, list]) => list.length > 0);
}
